<template>
  <div
    v-if="routesMapped"
    class="d-flex align-items-center px-3 py-3 sitemap-container"
  >
    <div class="flex-grow-1 font-12 d-flex align-items-center">
      <div v-if="assignedRequestCount">
        <em class="far fa-list-alt mr-2 color-primary-4 font-14" />
        <span class="color-black">{{ $t('YouHave') }}</span>
        <span class="color-primary-4 font-weight-bold mx-1">
          {{ assignedRequestCount }} {{ $t('Requests') }}
        </span>
        <span class="color-black">{{ $t('AssignedActive') }}</span>
      </div>
      <div v-if="hasRequestInfo">
        <div>
          <div class="d-flex align-items-center">
            <em :class="`fa fa-circle color-${statusColor}`" />
            <div class="color-black-1 font-12 ml-2">
              {{ $t('ApplicationHeader.HeaderText') }}
            </div>
            <span class="color-primary-4 font-12 font-weight-bold ml-2">
              #
              <span id="selectedRequestNumber">
                {{ sitemapInfo.request.requestNumber }}
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="font-10 color-primary-8">
      <span class="font-weight-bold mr-2">{{ $t('AreYouHere') }}:</span>
      <span>{{ routesMapped }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { name as appModuleName } from '@/store/modules/app';
import { requestStatusColor } from '@/utils/constants/requestStatus';

export default {
  name: 'TheSitemap',
  computed: {
    ...mapGetters(appModuleName, {
      sitemapInfo: 'getSitemapInfo',
    }),
    assignedRequestCount() {
      return this.sitemapInfo?.assignedRequestCount || null;
    },
    routesMapped() {
      return (this.sitemapInfo?.routes || []).join(' / ');
    },
    hasRequestInfo() {
      return !!Object.values(this.sitemapInfo?.request ?? {}).length;
    },
    statusColor() {
      return requestStatusColor[this.sitemapInfo?.request?.requestStatusId];
    },
  },
};
</script>

<style scoped lang="scss">
.sitemap-container {
  background: #f8f8f8 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  margin-right: 60px;
}
</style>
